import isEmpty from 'lodash/isEmpty';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';
import { API_STATUS_KEYS } from 'utils/constants';

export const buildStatus = state => ({
  [API_STATUS_KEYS.IN_PROGRESS]: state === API_STATUS_KEYS.IN_PROGRESS,
  [API_STATUS_KEYS.COMPLETE]:
    state === API_STATUS_KEYS.COMPLETE || (state && state !== API_STATUS_KEYS.IN_PROGRESS) || false,
  [API_STATUS_KEYS.ERROR]: state !== API_STATUS_KEYS.IN_PROGRESS && state !== API_STATUS_KEYS.COMPLETE ? state : null,
});

// IN_PROGRESS if ANY in progress
// COMPLETE if ALL complete
// ERROR if ALL complete and ANY error
export const mergeStatuses = (...statuses) => {
  const filtered = statuses.filter(s => !isEmpty(s));

  if (isEmpty(filtered)) return buildStatus(null);

  return {
    [API_STATUS_KEYS.IN_PROGRESS]: filtered.reduce((a, v) => a || v[API_STATUS_KEYS.IN_PROGRESS], false),
    [API_STATUS_KEYS.COMPLETE]: filtered.reduce((a, v) => a && v[API_STATUS_KEYS.COMPLETE], true),
    [API_STATUS_KEYS.ERROR]:
      filtered.reduce((a, v) => a || v[API_STATUS_KEYS.ERROR], false) &&
      filtered.reduce((a, v) => a && v[API_STATUS_KEYS.COMPLETE], true)
        ? API_STATUS_KEYS.ERROR
        : null,
  };
};

export const areFieldsEqual = (fields, object1, object2) => isEqual(pick(object1, ...fields), pick(object2, ...fields));

export const dashCaseToTitle = str =>
  str &&
  str
    .split('-')
    .map(s => `${s[0].toUpperCase()}${s.substr(1)}`)
    .join(' ');

export const isUpc = str => /^(\d{12,14})$/.test(str);
export const isISRC = str => /^[A-Z]{2}-?\w{3}-?\d{2}-?\d{5}$/.test(str);

// handles fallbacks. size is expected to be: ['small', 'medium', 'large']
export const artistImageUrlWithFallback = (image_url, size) => {
  if (size === 'large') {
    return image_url?.large;
  }
  if (size === 'medium') {
    return image_url?.medium || image_url?.large;
  }
  if (size === 'small') {
    return image_url?.small || image_url?.medium || image_url?.large;
  }
};
